import moment from 'moment';

export const isEmployeeMessage = (
  message: EmployeeOrgMessage | AnnouncementSummary,
): message is EmployeeOrgMessage => message && 'messageId' in message;

export type GenericMessageItem = {
  employeeId: number | null;
  groupId: string | null;
  messageBody: string;
  uniqueId: number;
  recipientName: string;
  sentAt: string;
  isUnread: boolean;
};

export const mapMessageToGenericMessageItem = (message: EmployeeOrgMessage | AnnouncementSummary) =>
  isEmployeeMessage(message)
    ? mapEmployeeMessageToGenericMessageItem(message)
    : mapAnnouncementToGenericMessageItem(message);

export const mapEmployeeMessageToGenericMessageItem = (
  message: EmployeeOrgMessage,
): GenericMessageItem => ({
  employeeId: message.employeeId,
  groupId: null,
  messageBody: message.messageBody,
  uniqueId: message.messageId,
  recipientName: `${message.nickname || message.firstName} ${message.lastName}`,
  sentAt: moment(message.sentAt).format('M/D/YYYY'),
  isUnread: !!message.unread,
});

export const mapAnnouncementToGenericMessageItem = (
  message: AnnouncementSummary,
  groupMembershipCount?: number,
): GenericMessageItem => ({
  employeeId: null,
  groupId: message.employeeGroupId,
  messageBody: message.messageBody,
  uniqueId: message.announcementId,
  recipientName: formatEmployeeGroupName(message.employeeGroupName, groupMembershipCount),
  sentAt: moment(message.sentAt).format('M/D/YYYY'),
  isUnread: false,
});

export const formatEmployeeGroupName = (name: string, count: number = 0) => `${name} (${count})`;
